import { render, staticRenderFns } from "./SliderItem.vue?vue&type=template&id=45be86cc&"
import script from "./SliderItem.vue?vue&type=script&lang=js&"
export * from "./SliderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports